import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { ObvionBanner } from "./ObvionBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://obvion.nl/media/zbcc1buq/familie-in-de-voortuin-van-gekocht-huis.jpg?rxy=0.52785265049416,0.6549865229110512&width=1632&height=800&format=webp&v=1dbe119face7cf0",
  documentsOutgoing:
    "https://obvion.nl/media/ohil12zl/vrouw-op-laptop-bank.jpg?rxy=0.35714285714285715,0.28761939494654604&width=1920&height=1280&format=WebP&v=1dbe10d8de0b560",
  documentsIncoming:
    "https://obvion.nl/media/ohil12zl/vrouw-op-laptop-bank.jpg?rxy=0.35714285714285715,0.28761939494654604&width=1920&height=1280&format=WebP&v=1dbe10d8de0b560",
  interestRates:
    "https://obvion.nl/media/225j1vzr/stel-is-blij-dat-ze-gaan-verhuizen.jpg?rxy=0.42217265461226117,0.34686787481043785&width=1632&height=800&format=webp&v=1dc55515bd06c10",
  maximumMortgage:
    "https://obvion.nl/media/fh4n0tj4/adviesgesprek-afgerond-mensen-geven-hand.jpg?rxy=0.5088348271446863,0.20502922778273688&width=1632&height=800&format=webp&v=1dc554e62426240",
  orientation:
    "https://obvion.nl/media/un3aknxd/sfeerbeeld-huis.jpg?width=1632&height=800&format=webp&v=1dc5550e12cda70",
};

export const ObvionPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <ObvionBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
